import apiService from './apiService';

/**
 * OAuth & SSO Management Service
 * Handles OAuth clients, secrets, allowed scopes, redirect URIs, and Developer API Keys.
 */
class OAuthService {
  /**
   * Get paginated list of OAuth clients
   */
  async getClients(params = {}) {
    const limit = params.limit || 20;
    const offset = params.offset || 0;
    return apiService.skaiNetRequest(`/api/v1/oauth/admin/clients?limit=${limit}&offset=${offset}`, {
      method: 'GET',
    });
  }

  /**
   * Get single OAuth client by ID
   */
  async getClient(id) {
    return apiService.skaiNetRequest(`/api/v1/oauth/admin/clients/${id}`, {
      method: 'GET',
    });
  }

  /**
   * Create a new OAuth client application
   * @param {Object} data
   * @param {string} data.clientName
   * @param {string} data.clientType - 'confidential' | 'public'
   * @param {string[]} data.redirectUris
   * @param {string[]} data.allowedScopes
   * @param {string} [data.logoUrl]
   * @param {string} [data.description]
   * @param {string} [data.privacyUrl]
   */
  async createClient(data) {
    return apiService.skaiNetRequest('/api/v1/oauth/admin/clients', {
      method: 'POST',
      data,
    });
  }

  /**
   * Update an existing OAuth client
   */
  async updateClient(id, data) {
    return apiService.skaiNetRequest(`/api/v1/oauth/admin/clients/${id}`, {
      method: 'PUT',
      data,
    });
  }

  /**
   * Delete an OAuth client
   */
  async deleteClient(id) {
    return apiService.skaiNetRequest(`/api/v1/oauth/admin/clients/${id}`, {
      method: 'DELETE',
    });
  }

  /**
   * Rotate client secret for confidential client
   */
  async rotateClientSecret(id) {
    return apiService.skaiNetRequest(`/api/v1/oauth/admin/clients/${id}/rotate-secret`, {
      method: 'POST',
    });
  }

  /**
   * Get list of Server API Keys
   */
  async getApiKeys(params = {}) {
    const limit = params.limit || 20;
    const offset = params.offset || 0;
    return apiService.skaiNetRequest(`/api/v1/oauth/admin/api-keys?limit=${limit}&offset=${offset}`, {
      method: 'GET',
    });
  }

  /**
   * Create a new Server API Key
   * @param {Object} data
   * @param {string} data.name
   * @param {string[]} data.scopes
   * @param {string} [data.expiresAt]
   */
  async createApiKey(data) {
    return apiService.skaiNetRequest('/api/v1/oauth/admin/api-keys', {
      method: 'POST',
      data,
    });
  }

  /**
   * Revoke a Server API Key
   */
  async revokeApiKey(id) {
    return apiService.skaiNetRequest(`/api/v1/oauth/admin/api-keys/${id}`, {
      method: 'DELETE',
    });
  }
}

const oauthService = new OAuthService();
export default oauthService;
